<template>
    <div>
        <v-menu
            content-class="segment-menu"
            v-model="showMenu"
            :close-on-content-click="false"
            :max-width="500"
            :position-x="x"
            :position-y="y"
            :nudge-bottom="20"
            absolute
            offset-y
        >
            <v-card>
                <v-form
                    ref="form"
                    @submit.prevent="save"
                    v-model="validMenuData"
                >
                    <v-list>
                        <v-subheader>Selected: {{ tagValue }}</v-subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <v-select
                                    ref="segmentTypeSelect"
                                    v-model="segmentData.type"
                                    :items="options"
                                    item-text="name"
                                    item-value="name"
                                    label="Type"
                                    return-object
                                    :rules="[validations.required()]"
                                    @keydown="handleDown"
                                    @click="handleClick"
                                ></v-select>
                                <slot
                                    name="menu-content"
                                    v-bind:tag-value="tagValue"
                                    v-bind:segment-data="segmentData"
                                ></slot>

                                <!-- <small v-if="hint">
                                Did you mean
                                <span class="text-primary">{{ hint }}</span
                                >?
                                <v-btn x-small @click="hintConfirmed()" text
                                    >Yes</v-btn
                                >
                                <v-btn x-small @click="hint = null" text
                                    >No</v-btn
                                >
                            </small> -->
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-card-actions v-if="type === '1'">
                        <v-spacer></v-spacer>

                        <v-btn text @click="showMenu = false">Cancel</v-btn>
                        <v-btn
                            :disabled="!validMenuData"
                            color="primary"
                            text
                            @click="save"
                            type="submit"
                            >Save</v-btn
                        >
                    </v-card-actions>
                    <v-card-actions v-if="type === '2'">
                        <v-row
                        align="center"
                        justify="space-around"
                        >
                        <v-btn text @click="showMenu = false" >Cancel</v-btn>
                        <v-btn text :disabled="!validMenuData" @click="save('overwrite')" color="warning">Find&Overwrite</v-btn>
                        <v-btn text :disabled="!validMenuData" @click="save('apply')" color="primary">Find&Add</v-btn>
                        <v-btn text :disabled="!validMenuData" @click="save('save')" color="success" type="submit">Save</v-btn>
                        </v-row>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findKey } from "lodash";
import validations from "@/views/partials/form/Validations.vue";
import { SET_FIELD_CHANGE } from "@/store/vendorOffer.module";

export default {
    props: ["params", "options","type"],
    watch: {
        params() {
            this.show();
        },
        segmentData: {
            deep: true,
            handler() {
                setTimeout(() => {
                    if (
                        this.segmentData.type &&
                        this.validMenuData &&
                        this.clickEvent &&
                        this.type !== '2'
                    ) {
                        this.save();
                    }
                }, 200);
            }
        }
    },
    computed: {
        ...mapGetters(["offerTableRows"]),
        tag() {
            return {
                value: this.tagValue
            };
        }
    },
    data() {
        return {
            validations: validations,
            showMenu: false,
            x: 0,
            y: 0,
            tagValue: null,
            hint: null,
            segmentData: {
                type: null,
                toAll: true
            },
            previousSelectedType: null,
            validMenuData: false,
            clickEvent: false
        };
    },
    methods: {
        show() {

            this.segmentData = {
                type: null,
                toAll: this.offerTableRows.length <= 5
            };

            let e = this.params.event;
            this.tagValue = this.params.selection.text;
            this.x = e.clientX;
            this.y = e.clientY;
            this.checkForHint();
            this.$nextTick(() => {
                this.showMenu = true;
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
                setTimeout(() => {
                    if (this.$refs.segmentTypeSelect) {
                        const input = this.$refs.segmentTypeSelect.$el.querySelector(
                            "input"
                        );
                        input.focus();
                    }
                }, 300);
            });
        },
        save(type) {
            this.$store.commit(SET_FIELD_CHANGE, true);
            if (this.validMenuData) {
                this.$emit("save", this.segmentData, this.params.selection,type);
                  this.showMenu = false;

                  this.previousSelectedType = this.segmentData.type;
                  this.segmentData = {
                        type: null,
                        toAll: true
                  };

            }
        },
        checkForHint() {
            let found = findKey(this.params.item, o => {
                return o && o.value && this.tagValue.indexOf(o.value) > -1;
            });
            if (found) {
                this.segmentData.segmentType = found;
            }

            this.hint = this.tagValue + " hint";
        },
        hintConfirmed() {},

        handleDown(event) {
          if (event.key === 'Enter') {
            if (
              this.previousSelectedType &&
              !this.segmentData.type &&
              !this.$refs.segmentTypeSelect.isMenuActive
            ) {
              this.segmentData.type = this.previousSelectedType;
              this.$nextTick(() => {
                this.$refs.segmentTypeSelect.blur();
              });
            } else if (
              !this.$refs.segmentTypeSelect.isMenuActive &&
              this.segmentData.type
            ) {
              this.$nextTick(() => {
                this.$refs.segmentTypeSelect.blur();
                this.save(event);
              });
            }
          }

          this.clickEvent = false;
        },

        handleClick() {
          this.clickEvent = true;
        }
    }
};
</script>

<style lang="sass" scoped>
.segment-menu
    overflow: hidden
</style>
